import { useDocumentTitle } from '../../util/hooks';

export function DocumentTitle({ title }: { title: string }) {
  useDocumentTitle(title);
  return null;
}
